// extracted by mini-css-extract-plugin
module.exports = {"CheckBox":"CheckBox_CheckBox__3sB24","doubleRow":"CheckBox_doubleRow__6H9Rh","noBottomMargin":"CheckBox_noBottomMargin__3pjQN"};